import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByUtmQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByUtmQueryType,
  AnalyticsSalesByUtmQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByUtmQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByUtmQueryType,
    AnalyticsSalesByUtmQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByUtmQueryType,
    AnalyticsSalesByUtmQueryVariablesType
  >(AnalyticsSalesByUtmQuery, options);
};
